module.exports = __webpack_public_path__ + "1a2abdd2a478700006a2cf066fb5cfa2.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts-es.html
// module id = 978
// module chunks = 0